<vex-table *ngIf="params"
  [params] = "params"
  (Change) = "getTableData($event)">
</vex-table>
